import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { UserNotificationCustomizations } from './user-notification-customizations.entity';

export class CreateUserNotificationCustomizationsDto extends Omit(UserNotificationCustomizations, BaseEntityFieldsArray) {}
